import { Injectable } from '@angular/core';
import { SettingsName } from '@app/class/SettingsName';
import { ConstantsService } from '@app/services/constantsService';
import * as signalR from '@microsoft/signalr';
import { HubConnectionState } from '@microsoft/signalr';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})

export class SignalRService {
    hubConnection: signalR.HubConnection;

    private apiUrl: string;

    constructor(private constantService: ConstantsService) {
        this.apiUrl = this.constantService.getApiUrl();
    }

    private joinedGroups = new Set<string>();

    public joinDeviceGroup(deviceSerial: string): void {
        if (this.joinedGroups.has(deviceSerial)) {
            return;
        }

        this.hubConnection.invoke(WebSocketCommands.JoinDeviceGroup, deviceSerial)
            .then(() => {
                this.joinedGroups.add(deviceSerial);
            })
            .catch((err) => console.error(`Error while joining Device group: ${err}`));
    }

    public initialise(): Promise<void> {
        if (this.hubConnection != null && this.hubConnection.state !== HubConnectionState.Disconnected) {
            return Promise.resolve();
        }

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(
                `${this.apiUrl}/valkyrieHub`,
                {
                    accessTokenFactory: () => window.sessionStorage.getItem(SettingsName.AccessToken.toString())
                }
            ).withAutomaticReconnect()

            .configureLogging(signalR.LogLevel.Information)
            .build();

        return this.startConnection();
    }

    public registerEvents<T>(event: string, subject: Subject<T>, ) {
        this.hubConnection.on(event, (data: T) => {
            subject.next(data);
        });
    }

    private startConnection(): Promise<void> {
        return this.hubConnection
            .start()
            .then(() => {
                console.log('Connection started');
            })
            .catch((err) => console.log(`Error while starting connection: ${err}`));
    }
}

export const enum WebSocketCommands {
    JoinDeviceGroup = "JoinDeviceGroup"
}

export const enum WebSocketEvents {
    LogMessage = "LogMessage",
    Pulse = "Pulse",
    CameraCommand = "CameraCommand",
    Tacho = "Tacho",
    VideoUpdate = "VideoUpdate",
    LogRequestUpdate = "LogRequestUpdate",
    ApplicationRequestUpdate = "ApplicationRequestUpdate",
    ConfigRequestUpdate = "ConfigRequestUpdate",
    DeviceMessageCommandUpdate = "DeviceMessageCommandUpdate",
    DiagnosticPacketUpdate = "DiagnosticPacketUpdate"
}
